import React from 'react'

import { arrayOf, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

// The steps are an <ol>: they are performed in order, so the numbering is semantic rather
// than decorative.
function HowItWorks({ title = '', paragraphs = EMPTY_ARRAY, steps = EMPTY_ARRAY }) {
  if (!title) return null

  return (
    <section
      className="ai-generator-landing__how-it-works"
      aria-labelledby="ai-generator-landing-how-it-works-title"
    >
      <div className="ai-generator-landing__how-it-works-container">
        <div className="ai-generator-landing__how-it-works-text">
          <h2
            id="ai-generator-landing-how-it-works-title"
            className="ai-generator-landing__how-it-works-title cgt-heading-500"
          >
            {title}
          </h2>
          {paragraphs.map((paragraph) => (
            <p key={paragraph} className="ai-generator-landing__how-it-works-paragraph cgt-body-md">
              {paragraph}
            </p>
          ))}
        </div>
        {steps.length > 0 && (
          <ol className="ai-generator-landing__how-it-works-steps">
            {steps.map((step) => (
              <li key={step} className="ai-generator-landing__how-it-works-step cgt-body-md">{step}</li>
            ))}
          </ol>
        )}
      </div>
    </section>
  )
}

HowItWorks.propTypes = {
  title: string,
  paragraphs: arrayOf(string),
  steps: arrayOf(string),
}

export default HowItWorks
